import { render, staticRenderFns } from "./cirFanConfig.vue?vue&type=template&id=1396b758&scoped=true&"
import script from "./cirFanConfig.vue?vue&type=script&lang=js&"
export * from "./cirFanConfig.vue?vue&type=script&lang=js&"
import style0 from "./cirFanConfig.vue?vue&type=style&index=0&id=1396b758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396b758",
  null
  
)

export default component.exports